import React, { useEffect } from "react";
import MainLayout from "../layouts/MainLayout";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom"; // ⬅️ Adicionado useSearchParams
import useNotification from "../hooks/useNotification";
import DashboardSummary from "../components/dashboard/DashboardSummary";
import MovementDraftRecoveryDialog from './Movements/Movement/components/MovementDraftRecoveryDialog'

const Dashboard = () => {
  const location = useLocation();
  const { showNotification } = useNotification();
  const navigate = useNavigate();
  const { module } = useParams();
  
  // ⬇️ 1. Lê o parâmetro ?view= da URL (ex: ?view=sac). Se não existir, usa 'padrao'
  const [searchParams] = useSearchParams();
  const view = searchParams.get("view") || "padrao";
  // Mapeamento para títulos amigáveis (fallback)
  const moduleTitles = {
    almoxarifado: 'Visão Geral - Almoxarifado',
    manutencao: 'Visão Geral - Manutenção',
    aluguel: 'Visão Geral - Aluguel',
  };
  const pageTitle = module === 'aluguel' && view === 'direcao'
    ? 'Painel de decisões administrativas'
    : module === 'aluguel' && view === 'financeiro'
      ? 'Dashboard de Faturamento'
      : module === 'aluguel' && view === 'logistica'
        ? 'Dashboard de Logística'
        : moduleTitles[module];

  useEffect(() => {
    if (location.state?.message) {
      showNotification("error", location.state.message);
      navigate(location.pathname, { replace: true });
    }
  }, [location.state, showNotification, navigate]);

  // Se o módulo não for válido, mostra 404 ou redireciona
  if (!module || !moduleTitles[module]) {
    return (
      <MainLayout selectedCompany="ALUCOM">
        <div className="container-fluid pt-3">
          <div className="alert alert-danger">
            Módulo de dashboard não encontrado.
          </div>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout selectedCompany="ALUCOM">
      <MovementDraftRecoveryDialog />
      <div className="container-fluid pt-3">
        {/* O título específico será definido dentro do DashboardSummary, mas mantemos o fallback aqui */}
        <h4 className="mb-4 text-muted">{pageTitle}</h4>

        {/* ⬇️ 2. Passamos tanto o 'module' quanto a 'view' para o componente filho */}
        <DashboardSummary module={module} view={view} />
      </div>
    </MainLayout>
  );
};

export default Dashboard;
